import React from "react";

import "../styles/carousel.scss";
import Slide from "./slide";

const Carousel = ({ activeIndex, carouselData }) => {
  return (
    <section>
      <div className="carousel__mobile">
        {!!carouselData &&
          carouselData.mobile.map((slide, index) => (
            <Slide
              slide={slide}
              index={index}
              activeIndex={activeIndex}
              key={index}
            />
          ))}
      </div>
      <div className="carousel__tab">
        {!!carouselData &&
          carouselData.tab.map((slide, index) => (
            <Slide
              slide={slide}
              index={index}
              activeIndex={activeIndex}
              key={index}
            />
          ))}
      </div>
      <div className="carousel__desktop">
        {!!carouselData &&
          carouselData.desktop.map((slide, index) => (
            <Slide
              slide={slide}
              index={index}
              activeIndex={activeIndex}
              key={index}
            />
          ))}
      </div>
    </section>
  );
};

export default Carousel;
